import { Flex, Typography } from "antd"
import React from "react"
import { Outlet } from "react-router-dom"

import { MAIN_CONTENT_STICKY_TOP_CLASS } from "../../../../components/main-content.ts"
import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import SettingsLayoutTabs from "./SettingsLayoutTabs.tsx"

const { Title } = Typography

export function SettingsLayout() {
  const moduleAccess = useAppSelector(
    (state) => state?.auth?.userInfo?.permissions?.codes
  )

  return (
    // Grows with a tall tab so the sticky title never leaves its parent; a grid,
    // not `min-h-full` on the column, so the tabs' percentage heights resolve.
    <div className={"grid grid-cols-1 min-h-full -mt-2"}>
      <Flex vertical gap={"middle"}>
        <div
          className={`${MAIN_CONTENT_STICKY_TOP_CLASS} bg-background z-10 pt-2`}
        >
          <Flex justify={"space-between"}>
            <Title className={"text-start"} level={2}>
              Settings
            </Title>
          </Flex>
          <SettingsLayoutTabs permissions={moduleAccess} />
        </div>
        <Flex flex={1}>
          <Outlet />
        </Flex>
      </Flex>
    </div>
  )
}
